import { connectMonthListLabel } from './connectMonthListLabel';
import { MonthListLabel as MonthListLabelPure } from './MonthListLabel';

export const MonthListLabel = connectMonthListLabel(MonthListLabelPure);
